module.exports = __webpack_public_path__ + "static/icon-5-35384e8be872909a85cd8e1845cd3a8b.png";